import Check from '@/components/Check';
import MarketingSection from './MarketingSection';

export default function MarketingFeatures({
  features,
}) {
  return (
    <MarketingSection className="bg-green-600 text-white" sectionTitle="Al concluir este programa tendrás las habilidades para">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:px-20">
        {features.map(({ title, description }, index) => (
          <div key={`features-${index}`} className="lg:col-span-6">
            <div className="flex items-start space-x-4">
              <div className="mt-px">
                <Check size="w-6 h-6 text-green-400" />
              </div>
              <div className="flex flex-col space-y-2">
                <h4 className="font-semibold text-lg lg:text-xl">
                  {title}
                </h4>
                <p className="text-base font-medium text-green-200">
                  {description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </MarketingSection>
  );
}
